<template>
  <li>
    <div class="details">
      <h3>
        {{ client.name }}
        <span v-if="client.company">&ndash; {{ client.company }}</span>
        <span v-if="$vlastMode && client.activation_notified_at" class="small">(Activation Email Sent: {{ client.activation_notified_at | dateTimezone( $user.timezone, $user.date_format_preference, true, true) }})</span>
      </h3>
      <div class="row">
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'clients.profile.show', params: { id: client.id }}" exact>
            Profile
          </router-link>
        </div>
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'clients.requests.index', params: { clientId: client.id }}" exact>
            Requests
          </router-link>
        </div>
        <div class="col-xs-6 col-lg-3">
          <router-link tag="a" class="btn btn-sm btn-block btn-default" :to="{ name: 'clients.bookings.index', params: { clientId: client.id }}" exact>
            Bookings
          </router-link>
        </div>
        <div class="col-xs-6 col-lg-3" v-if="$paymentsModuleEnabled">
          <router-link tag="a" :to="{ name: 'clients.payments.index', params: { clientId: client.id }}" class="btn btn-sm btn-block btn-default">Payments</router-link>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    client: {
      required: true,
      type: Object
    }
  }
}
</script>
